import { Injectable } from '@angular/core';

export interface TableDateFilterConstraint {
  value: string;
  matchMode: 'dateBefore' | 'dateAfter';
  operator: 'and';
}

export type TableDateFilters = Record<string, TableDateFilterConstraint[]>;

export interface TableDateRange {
  from: Date | null;
  to: Date | null;
}

@Injectable({
  providedIn: 'root'
})
export class TableFilterService {
  buildDateRangeFilters(range: TableDateRange, field: string, timezone: string): TableDateFilters | undefined {
    const constraints: TableDateFilterConstraint[] = [];
    const normalizedTimezone = timezone || '+0000';

    if (range.from) {
      constraints.push({
        value: this.toUtcIsoString(range.from, '00:00:00', normalizedTimezone),
        matchMode: 'dateBefore',
        operator: 'and'
      });
    }

    if (range.to) {
      constraints.push({
        value: this.toUtcIsoString(range.to, '23:59:59', normalizedTimezone),
        matchMode: 'dateAfter',
        operator: 'and'
      });
    }

    if (!constraints.length) {
      return undefined;
    }

    return {
      [field]: constraints
    };
  }

  private toUtcIsoString(date: Date, time: string, timezone: string): string {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');

    return new Date(`${year}-${month}-${day}T${time}${timezone}`).toISOString();
  }
}
